export enum countries {
    BANGLADESH = 'bangladesh',
    JORDAN = 'jordan',
}
